import request from "@/utils/request";
import config from "@/utils/config";
import requestMA from '@/utils/request-ma';
let baseApi = config.env.VUE_APP_BRAND === 'COTTI' ? '/cotti-capi' : '/teacat-capi'

export function getPointsActivityInfo(data,headers) {
    return request({
        url: `${baseApi}/pointsActivity/info`,
        method: "POST",
        data,
    });
}

export function getPointsDetails(data,headers) {
    return request({
        url: `${baseApi}/pointsActivity/getPointsDetail`,
        method: "POST",
        data,
    });
}

export function submitLotteryWish(data,headers) {
    return request({
        url: `${baseApi}/pointsActivity/submitLotteryWish`,
        method: "POST",
        data,
    });
}
// 张杰演唱会参与抽奖
export function submitLotteryWishForce(data,headers) {
    return request({
        url: `${baseApi}/pointsActivity/submitLotteryWishForce`,
        method: "POST",
        data,
    });
}

// 张杰演唱会获取历史记录列表
export function getHistoryList(data,headers) {
    return request({
        url: `${baseApi}/pointsActivity/historyActivityList`,
        method: "POST",
        data,
    });
}

export function prizeList(data,headers) {
    return request({
        url: `${baseApi}/pointsActivity/prizeList`,
        method: "POST",
        headers,
        data,
    });
}

// 兑换验证
export function getValidateData(data,headers) {
    return request({
        url: `${baseApi}/pointsActivity/validate`,
        method: "POST",
        headers,
        data,
    });
}

// 兑换
export function getExchangeData(data,headers) {
    return request({
        url: `${baseApi}/pointsActivity/exchange`,
        method: "POST",
        headers,
        data,
    });
}
export function getDialogAdInfo(data,headers) {
    return requestMA({
        url: `${baseApi}/customer/position/list`,
        method: "POST",
        data,
    });
}

export function updateFrequency(data,headers) {
    return request({
        url: `${baseApi}/customer/position/updateFrequency`,
        method: "POST",
        data,
    });
}

// 获取历史记录列表
export function getHistory(data,headers) {
    return request({
        url: `${baseApi}/pointsActivity/history`,
        method: "POST",
        data,
    });
}
export function transformTinyUrl(data) {
    return request({
        url: `${baseApi}/common/sys/base/transformTinyUrl`,
        method: "POST",
        data,
    });
}

